/***/

import axios from 'axios'
import store from '@/assets/js/store'
import router from './router'

router.afterEach((to, from, next) => {
  if (to.meta.breadcrumb ){
     store.commit('currentBreadcrumb', to.meta.breadcrumb)
  }
 
  if (window.scrollY > 0 ) {

    $('html,body').animate({
      scrollTop: 0
    }, 'slow');

}
});


export default axios;



// WEBPACK FOOTER //
// ./src/http.js